<app-header [shopping]="true"/>

<div class="shopping-cart-page">
  <div class="shopping-cart-page-title">
    <p [innerHTML]="'Selected Tours Overview' | translate"></p>
  </div>

  <div class="table-wrapper">
    @let rates = settingsService.quotes!.conversion_rates;

    <table>
      <thead>
      <tr>
        <th>{{ "Image" | translate }}</th>
        <th>{{ "Tour name" | translate }}</th>
        <th>{{ "Currency" | translate }}</th>
        <th>{{ "Price until 4 people" | translate }}</th>
        <th>{{ "Price from 5 until 7 people" | translate }}</th>
        <th>{{ "Delete" | translate }}</th>
      </tr>
      </thead>
      <tbody>
        @for (tour of shoppingService.shoppedTours; track tour; let i = $index) {
          @let price = +tour.price;
          @let groupPrice = +tour.groupPrice;

          <tr>
            <td><img class="image-width" [src]="tour.url" alt="armenia" (click)="goToTour(tour)"></td>
            <td>{{ tour.title | translate }}</td>
            <td>
              <table class="child-table">
                <tr>
                  <td>USD</td>
                </tr>
                <tr>
                  <td>RUB</td>
                </tr>
                <!--                        <tr>
                <td>EUR</td>
              </tr>-->
                <tr>
                  <td>AMD</td>
                </tr>
              </table>
            </td>
            <td>
              <table class="child-table">
                <tr>
                  <td>{{ math.floor(price * rates.USD) }} $</td>
                </tr>
                <tr>
                  <td>{{ math.floor(price * rates.RUB) }} &#8381;</td>
                </tr>
                <!--                        <tr>
                <td>{{math.floor(tour.price * settingsService.quotes?.USD_EUR)}}&euro;</td>
              </tr>-->
                <tr>
                  <td>{{ math.floor(price * rates.AMD) }} &#1423;</td>
                </tr>
              </table>
            </td>
            <td>
              <table class="child-table">
                <tr>
                  <td>{{ math.floor(groupPrice * rates.USD) }} $</td>
                </tr>
                <tr>
                  <td>{{ math.ceil(groupPrice * rates.RUB) }} &#8381;</td>
                </tr>
                <!--                        <tr>
                <td>{{math.floor(tour.groupPrice * settingsService.quotes?.USD_EUR)}}&euro;</td>
              </tr>-->
                <tr>
                  <td>{{ math.ceil(groupPrice * rates.AMD) }} &#1423;</td>
                </tr>
              </table>
            </td>
            <td class="delete-tour-wrapper" (click)="removeTour(i)">
              <i class="fas fa-trash-alt delete-tour"></i>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  <div class="total-table-wrapper">
    <app-prices-table
      [price]="shoppingService.totalToursPrice"
      [groupPrice]="shoppingService.totalGroupToursPrice"
      [totalTable]="true"
    />
  </div>

  <div class="book-online-form">
    <app-book-online-section [toursId]="shoppingService.shoppedToursIds"/>
  </div>


</div>
